import { cn } from "@/lib/utils";
import { NavLink } from "react-router";


function PrimaryContainerComponent({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cn("px-4 lg:px-8 xl:px-10 2xl:px-16 3xl:px-24", className)}>
            {props.children}
        </div>
    );
}

export { PrimaryContainerComponent };